import React from 'react';
import { default as Styles, colors } from '../styles';
import { unwrap_arr, round_to } from '../utils';
import { RGB_Linear_Shade } from '../utils/chart';

const LegendUpDown = ({
  active,
  chart_width,
  min,
  max,
  source = false,
  title = false,
}) => {
  const past_was_better = unwrap_arr(active).raw === max;
  const diff = max - min;
  const total = round_to((diff / max) * 100, 1);
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        ...Styles.elevation('max'),
      }}
    >
      <div
        style={{
          color: colors.grey,
          height: '100%',
          ...Styles.padded('l'),
          ...Styles.col_between('start'),
          ...Styles.stretch,
        }}
      >
        <div>
          {title && (
            <p style={{ ...Styles.bold, ...Styles.uppercase }}>{title}</p>
          )}
          {source && chart_width > 200 && (
            <p style={{ ...Styles.uppercase, ...Styles.font('xs') }}>
              Source
              <span style={{ ...Styles.bold }}> {source}</span>
            </p>
          )}
          <p
            style={{
              color: past_was_better ? colors.accent : colors.green,
              ...Styles.numbers,
              ...Styles.bold,
              ...Styles.font(chart_width > 200 ? 'xxl' : 'l'),
            }}
          >
            {total}%
          </p>
        </div>
        <div>
          <p
            style={{
              ...Styles.truncate_sx(100),
            }}
          >
            {unwrap_arr(active).label}
          </p>
          {active.map((v, index) => {
            return (
              <div
                key={v.id}
                style={{
                  ...Styles.uppercase,
                  color: RGB_Linear_Shade(
                    (index * 30) / 100,
                    past_was_better ? colors.accent : colors.green,
                  ),
                  ...Styles.paddedY('S'),
                  ...Styles.row_start('center'),
                }}
              >
                {index === 0 ? (
                  <p style={{ ...Styles.font('xs') }}>WAS</p>
                ) : (
                  <p style={{ ...Styles.font('xs') }}>IS</p>
                )}
                <p
                  style={{
                    ...Styles.bold,
                    ...Styles.numbers,
                    textAlign: 'right',
                    flexGrow: 1,
                  }}
                >
                  {v.raw}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default LegendUpDown;
